module.exports = __webpack_public_path__ + "img/title-text.7ca08538.png";